export default __webpack_public_path__ + "static/media/photo.732e4882.png";